import { render, staticRenderFns } from "./PaymentNoteColumn.vue?vue&type=template&id=0556d766&scoped=true&"
import script from "./PaymentNoteColumn.vue?vue&type=script&lang=js&"
export * from "./PaymentNoteColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0556d766",
  null
  
)

export default component.exports